import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PropertyUnitsComponent } from './pages/property-units/property-units.component';
import { EditPropertyUnitComponent } from './pages/edit-property-unit/edit-property-unit.component';
import { PropertyUnitDetailsComponent } from './pages/property-unit-details/property-unit-details.component';
import { AddPropertyUnitComponent } from './components/add-property-unit/add-property-unit.component';

const routes: Routes = [
  {
    path: '',
    component: PropertyUnitsComponent
  },
  {
    path: 'add',
    component: AddPropertyUnitComponent
  },
  {
    path: ':id',
    component: PropertyUnitDetailsComponent
  },
  {
    path: ':id/edit',
    component: EditPropertyUnitComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PropertyUnitsRoutingModule { }
